import script from "./ProductList.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductList.vue?vue&type=script&setup=true&lang=js"

import "./ProductList.vue?vue&type=style&index=0&id=b4330dec&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b4330dec"]])

export default __exports__